export const UserRoles = {
  storeAdmin: { id: 2, label: 'Lojista' },
  promoter: { id: 3, label: 'Promotor' },
};